import React, { useState } from "react";
import "./HireForm.css";
import { ref as dbRef, push } from "firebase/database";
import { ref as sRef, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebase";

export default function HireForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    role: "",
  });

  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setMessage("Please upload your resume file.");
      return;
    }

    setSubmitting(true);
    setMessage("");
    setUploadProgress(0);

    try {
      // 1. Upload file to Firebase Storage
      const uniqueFileName = `resumes/${Date.now()}_${file.name}`;
      const fileRef = sRef(storage, uniqueFileName);
      const uploadTask = uploadBytesResumable(fileRef, file);

      const resumeUrl = await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setUploadProgress(progress);
          },
          (error) => {
            console.error("Upload error:", error);
            reject(error);
          },
          async () => {
            try {
              const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
              resolve(downloadUrl);
            } catch (err) {
              reject(err);
            }
          }
        );
      });

      // 2. Save data to Database
      const applicationsRef = dbRef(db, "careers");
      await push(applicationsRef, {
        ...formData,
        resumeLink: resumeUrl,
        createdAt: Date.now(),
      });

      setMessage("Application submitted successfully ✅");
      setFormData({
        name: "",
        email: "",
        phone: "",
        role: "",
      });
      setFile(null);
      setUploadProgress(0);

      // Reset file input element visually
      e.target.reset();
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong. Please try again.");
      setUploadProgress(0);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="hire-section">
      <h2 className="hire-title">Join Our Team</h2>
      <p className="hire-subtitle">Fill the form below to apply</p>

      <form className="hire-form" onSubmit={handleSubmit}>
        {/* NAME */}
        <div className="form-group">
          <label>Name</label>
          <input
            name="name"
            type="text"
            placeholder="Enter your full name"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        {/* EMAIL */}
        <div className="form-group">
          <label>Email</label>
          <input
            name="email"
            type="email"
            placeholder="example@mail.com"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* PHONE */}
        <div className="form-group">
          <label>Phone</label>
          <input
            name="phone"
            type="tel"
            placeholder="+91 - XXXXX XXXXX"
            required
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* ROLE DROPDOWN */}
        <div className="form-group">
          <label>Role Applying For</label>
          <select
            name="role"
            required
            value={formData.role}
            onChange={handleChange}
          >
            <option value="">Select a role</option>
            <option>Dental Surgeon</option>
            <option>Orthodontist</option>
            <option>Endodontist</option>
            <option>Oral Surgeon</option>
            <option>Pediatric Dentist</option>
            <option>Dental Hygienist</option>
            <option>Dental Assistant</option>
            <option>Patient Coordinator</option>
            <option>Clinic Manager</option>
            <option>Reception & Front Desk</option>
          </select>
        </div>

        {/* RESUME FILE UPLOAD */}
        <div className="form-group">
          <label>Resume (PDF, DOC, DOCX)</label>
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            required
            onChange={handleFileChange}
          />
          {uploadProgress > 0 && (
            <p style={{ marginTop: 8, fontSize: 14, color: "#6a00ff" }}>
              Uploading resume: {uploadProgress}%
            </p>
          )}
        </div>

        {/* SUBMIT */}
        <button type="submit" className="apply-btn" disabled={submitting}>
          {submitting ? "Submitting..." : "Submit Application"}
        </button>

        {message && <p style={{ marginTop: 12 }}>{message}</p>}
      </form>
    </section>
  );
}
